import {Component, Input, OnInit} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {OpeLogError, EtatCarte} from "@domain/admin/ca/ope-log-error";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'un item de la liste des erreurs du suivi des relevés
 *
 * @author Guillaume TRAVOT
 * @date 31/03/2026
 */
@Component({
    host: {'data-test-id': 'suivi-releve-error-list-item'},
    selector: 'suivi-releve-error-list-item',
    templateUrl: './suivi-releve-error-list-item.component.html'
})
export class SuiviReleveErrorListItemComponent extends ListViewItem<OpeLogError> implements OnInit {
    /** Options supplémentaires */
    @Input() public extraOptions: {
        openDetail: (error: OpeLogError) => void,
        typesErreur: Array<{code: EtatCarte, libelle: string, solution: string}>
    };

    /** Libellé de l'erreur */
    libelleErreur: string;

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService) {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        const typeErreur = this.extraOptions.typesErreur.find(t => t.code === this.data.erreur);
        this.libelleErreur = typeErreur
            ? this.translateService.instant(typeErreur.libelle)
            : this.translateService.instant('admin.frais.cartes.suivi.erreur.NON_REFERENCE');
    }

    /**
     * Ouvre le détail de l'erreur
     */
    openDetail(): void {
        this.extraOptions.openDetail(this.data);
    }
}